/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector(
    '#shopify-section-template--23610116407516__section_image_slideshow_rMqkGt'
  );

  if (!section) return;

  const slider = section.querySelector('.swiper');
  const prev = section.querySelector('.dj-image-carousel-arrow--prev');
  const next = section.querySelector('.dj-image-carousel-arrow--next');

  if (!slider || !prev || !next) return;

  prev.addEventListener('click', function (event) {
    event.preventDefault();
    event.stopPropagation();

    if (slider.swiper) {
      slider.swiper.slidePrev();
    }
  });

  next.addEventListener('click', function (event) {
    event.preventDefault();
    event.stopPropagation();

    if (slider.swiper) {
      slider.swiper.slideNext();
    }
  });
});
